import React from 'react';
import { Card } from '@dopomogai/ui';

export function WhatIsThis() {
  return (
    <section className="max-w-6xl mx-auto px-6 py-8">
      <Card>
        <div className="p-4 space-y-2">
          <div className="text-xl font-extrabold">What this is</div>
          <p className="text-slate-700">Co-ownership units in an AI agent. Units are non-transferable and not tradable. Returns are not guaranteed. Read the Terms before investing.</p>
        </div>
      </Card>
    </section>
  );
}


